import $ from 'jquery';

class NotfoundController {
  constructor() {
    "ngInject";
  }

}

export default NotfoundController;



// WEBPACK FOOTER //
// ./client/pages/404/notfound.controller.js